import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { H3 } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import FilterBar from './components/FilterBar';
import KPICards from './components/KPICards';
import { debounce } from 'lodash';
import axios from 'axios';
import Loader from '../../../Loader/Loader';
import './style.scss';
import { baseURL } from '../../../../Services/api/baseURL';

function GPReportsComponent() {
    const [view, setView] = useState('products');
    const [drilledProduct, setDrilledProduct] = useState(null);
    const [filterStore, setFilterStore] = useState('');
    const [filterCat, setFilterCat] = useState('');
    const [filterSubcat, setFilterSubcat] = useState('');
    const [filterPeriod, setFilterPeriod] = useState('month');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [token, setToken] = useState(null);
    const [data, setData] = useState([]);
    const [subCollectionData, setSubCollectionData] = useState([]);
    const [collectionData, setCollectionData] = useState([]);
    const [storeData, setStoreData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [summary, setSummary] = useState({});

    console.log('storeData:', storeData, collectionData, subCollectionData);
    // Initialize token
    useEffect(() => {
        const storedToken = JSON.parse(localStorage.getItem('token'));
        if (storedToken) {
            setToken(storedToken);
        }
    }, []);

    const fetchStores = async () => {
        const token = await JSON.parse(localStorage.getItem("token"));
        try {
            const stores = await axios.get(`${baseURL}/api/store/get-all-stores`, {
                headers: { Authorization: `${token}` },
            });
            let filteredData = stores?.data?.data.filter((item) => item.status === "active");
            setStoreData(filteredData || []);
        } catch (error) {
            console.log(error);
        }
    };
    
    const fetchCategoryList = async () => {
        const token = await JSON.parse(localStorage.getItem("token"));
        try {
            const collectData = await axios.get(`${baseURL}/api/admin/get-collections?page=1&limit=1000`, {
                headers: { Authorization: `${token}` },
            });
            let data = collectData?.data?.data.filter((item) => item.status === "active");
            setCollectionData(data);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchSubcollectionsList = async () => {
        const token = await JSON.parse(localStorage.getItem("token"));
        try {
            const response = await axios.get(`${baseURL}/api/admin/get-sub-collections?page=1&limit=1000`, {
                headers: { Authorization: `${token}` }
            });
            let data = response?.data?.data.filter((item) => item.status === "active");
            setSubCollectionData(data);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        fetchStores();
        fetchCategoryList();
        fetchSubcollectionsList();
    }, []);

    // Debounced search
    const debouncedSearch = useRef(
        debounce(async (searchTerm) => {
            setSearchTerm(searchTerm);
        }, 300)
    ).current;

    // Fetch data from API with filters
    const fetchGPData = async () => {
        try {
            setIsLoading(true);
            const token = await JSON.parse(localStorage.getItem("token"));
            
            // Build params object similar to ProductsTable
            let params = {};
            
            // Check if any filters are applied
            const hasFilters = filterCat || filterSubcat || filterStore || startDate || endDate || searchTerm;
            
            if (filterCat) {
                params.category_id = filterCat;
            }
            if (filterSubcat) {
                params.sub_category_id = filterSubcat;
            }
            if (filterStore) {
                params.storeId = filterStore;
            }
            if (startDate) {
                params.start_date = startDate;
            }
            if (endDate) {
                params.end_date = endDate;
            }
            if (filterPeriod) {
                params.period = filterPeriod;
            }
            if (searchTerm) {
                params.search = searchTerm;
            }

            // Add pagination params only when no filters are applied
            if (!hasFilters) {
                params.page = currentPage;
                params.limit = perPage;
            }

            let fetchedData = [];
            let responseTotal = 0;
            let summary = {};
            try {
                const response = await axios.get(`${baseURL}/api/gbrepots/get-global-revenue`, {
                    params: params,
                    headers: { Authorization: `${token}` }
                });
                
                if (response?.status === 200 && response?.data?.data) {
                    fetchedData = response.data.data.products || response.data.data;
                    responseTotal = response?.data?.total || fetchedData.length;
                    summary = response.data.data.summary || {};
                    setSummary(summary);
                } else {
                    throw new Error('No data from GP reports endpoint');
                }
            } catch (error) {
                fetchedData = [];
                responseTotal = 0;
            }
            
            console.log('Fetched GP data:', fetchedData, 'Total:', responseTotal);
            setData(fetchedData);
            setTotalRows(responseTotal);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching GP data:', error);
            setData([]);
            setIsLoading(false);
        }
    };

    // Trigger fetch when filters or search term changes
    useEffect(() => {
        if (token) {
            fetchGPData();
        }
    }, [token, filterCat, filterSubcat, filterStore, startDate, endDate, filterPeriod, searchTerm, currentPage, perPage]);

    // Handle pagination change
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // Reset pagination when filters change
    useEffect(() => {
        setCurrentPage(1);
    }, [filterCat, filterSubcat, filterStore, startDate, endDate, filterPeriod, searchTerm]);

    const getFilteredProducts = () => {
        // Filter by search term on name, category, or subcategory
        let filtered = data.filter(p => {
            if (!searchTerm) return true;
            const searchLower = searchTerm.toLowerCase();
            return (
                (p?.productName?.toLowerCase().includes(searchLower)) ||
                (p?.name?.toLowerCase().includes(searchLower)) ||
                (p?.cat?.toLowerCase().includes(searchLower)) ||
                (p?.subcat?.toLowerCase().includes(searchLower)) ||
                (p?.category?.toLowerCase().includes(searchLower)) ||
                (p?.subCategory?.toLowerCase().includes(searchLower)) ||
                (p?.categoryName?.toLowerCase().includes(searchLower)) ||
                (p?.subCategoryName?.toLowerCase().includes(searchLower))
            );
        });
        
        return filtered.map(p => ({
            ...p,
            sellingPriceIncGST:  p.sellingPriceIncGST  || 0,
            outputGST:           p.outputGST            || 0,
            revenue:             p.revenue              || 0,
            purchasePriceIncGST: p.purchasePriceIncGST  || 0,
            inputGST:            p.inputGST             || 0,
            cogs:                p.cogs                 || 0,
            gp:                  p.grossProfit          || 0,
            pct:                 p.gpPercentage         || 0,
        }));
    };

    const getTotals = (rows) => {
        const t = rows.reduce((a, x) => ({
            revenue: a.revenue + x.revenue,
            cogs: a.cogs + x.cogs,
            gp: a.gp + x.gp,
            revenueIncGST: a.revenueIncGST + (x.sellingPriceIncGST || 0),
            cogsIncGST: a.cogsIncGST + (x.purchasePriceIncGST || 0),
        }), { revenue: 0, cogs: 0, gp: 0, revenueIncGST: 0, cogsIncGST: 0 });
        t.pct = t.revenue ? (t.gp / t.revenue * 100) : 0;
        return t;
    };

    const currentRows = getFilteredProducts();
    const totals = getTotals(currentRows);

    const fmt = (n) => (n < 0 ? '-' : '') + '$' + Math.abs(n).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const pct = (n) => n.toFixed(1) + '%';

    // DataTable columns
    const columns = [
        {
            name: 'Product Name',
            selector: row => row.productName,
            sortable: true,
            minWidth: '160px',
            cell: (row) => (
                <span className="gp-cell-truncate" data-tooltip-id="gp-table-tooltip" data-tooltip-content={row.productName}>
                    {row.productName}
                </span>
            )
        },
        {
            name: 'Category',
            selector: row => row.categoryName,
            sortable: true,
            cell: (row) => (
                <span
                    style={{ fontSize: '12px' }}
                    className="badge badge-light-info gp-cell-truncate"
                    data-tooltip-id="gp-table-tooltip"
                    data-tooltip-content={row.categoryName}
                >
                    {row.categoryName}
                </span>
            )
        },
        {
            name: 'Sub-category',
            selector: row => row.subCategoryName,
            sortable: true,
            cell: (row) => (
                <span className="gp-cell-truncate" data-tooltip-id="gp-table-tooltip" data-tooltip-content={row.subCategoryName}>
                    {row.subCategoryName}
                </span>
            )
        },
        {
            name: 'Orders',
            selector: row => row.orders,
            sortable: true,
            cell: (row) => <span data-tooltip-id="gp-table-tooltip" data-tooltip-content={row.orders}>{row.orders}</span>
        },
        {
            name: 'Qty Sold',
            selector: row => row.qtySold,
            sortable: true,
            cell: (row) => <span data-tooltip-id="gp-table-tooltip" data-tooltip-content={row.qtySold}>{row.qtySold}</span>
        },
        {
            name: 'Sales (Inc GST)',
            selector: row => row.sellingPriceIncGST,
            sortable: true,
            cell: (row) => (
                <span data-tooltip-id="gp-table-tooltip" data-tooltip-content={fmt(row.sellingPriceIncGST)}>
                    {fmt(row.sellingPriceIncGST)}
                </span>
            )
        },
        {
            name: 'Sales GST',
            selector: row => row.outputGST,
            sortable: true,
            cell: (row) => (
                <span style={{ color: '#6c757d' }} data-tooltip-id="gp-table-tooltip" data-tooltip-content={fmt(row.outputGST)}>
                    {fmt(row.outputGST)}
                </span>
            )
        },
        {
            name: 'Sales (Ex GST)',
            selector: row => row.revenue,
            sortable: true,
            cell: (row) => (
                <span data-tooltip-id="gp-table-tooltip" data-tooltip-content={fmt(row.revenue)}>
                    {fmt(row.revenue)}
                </span>
            )
        },
        {
            name: 'COGS (Inc GST)',
            selector: row => row.purchasePriceIncGST,
            sortable: true,
            cell: (row) => (
                <span data-tooltip-id="gp-table-tooltip" data-tooltip-content={fmt(row.purchasePriceIncGST)}>
                    {fmt(row.purchasePriceIncGST)}
                </span>
            )
        },
        {
            name: 'COGS GST',
            selector: row => row.inputGST,
            sortable: true,
            cell: (row) => (
                <span style={{ color: '#6c757d' }} data-tooltip-id="gp-table-tooltip" data-tooltip-content={fmt(row.inputGST)}>
                    {fmt(row.inputGST)}
                </span>
            )
        },
        {
            name: 'COGS (Ex GST)',
            selector: row => row.cogs,
            sortable: true,
            cell: (row) => (
                <span data-tooltip-id="gp-table-tooltip" data-tooltip-content={fmt(row.cogs)}>
                    {fmt(row.cogs)}
                </span>
            )
        },
        {
            name: 'Gross Profit ($)',
            selector: row => row.grossProfit,
            sortable: true,
            cell: (row) => (
                <span
                    style={{ color: row.grossProfit >= 0 ? '#28a745' : '#dc3545' }}
                    data-tooltip-id="gp-table-tooltip"
                    data-tooltip-content={fmt(row.grossProfit)}
                >
                    {fmt(row.grossProfit)}
                </span>
            )
        },
        {
            name: 'Gross Margin (%)',
            selector: row => row.gpPercentage,
            sortable: true,
            cell: (row) => (
                <span data-tooltip-id="gp-table-tooltip" data-tooltip-content={pct(row.gpPercentage)} style={{ color: row.gpPercentage >= 0 ? '#28a745' : '#dc3545' }}>
                    {pct(row.gpPercentage)}
                </span>
            )
        }
    ];

    return (
        <Fragment>
            <Container fluid={true} className="gp-report" style={{ paddingTop: '30px' }}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody style={{ padding: '15px' }}>
                                <Row className='pb-2'>
                                    <Col md={6} lg={6} xl={6}>
                                        <div>
                                            <H3 className='mb-0 font-bold'>
                                                Gross Profit Report
                                            </H3>
                                        </div>
                                    </Col>
                                    <Col md={6} lg={6} xl={6}>
                                        <div className="file-content file-content1 justify-content-end">
                                            <div className='mb-0 form-group position-relative search_outer d-flex align-items-center'>
                                                <i className='fa fa-search' style={{ top: 'unset' }}></i>
                                                <input 
                                                    className='form-control border-0' 
                                                    style={{ maxWidth: '195px' }} 
                                                    onChange={(e) => debouncedSearch(e.target.value)} 
                                                    type='text' 
                                                    placeholder='Search products...' 
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>

                            <div style={{ padding: '15px' }}>
                                <FilterBar 
                                    filterPeriod={filterPeriod}
                                    setFilterPeriod={setFilterPeriod}
                                    filterStore={filterStore}
                                    setFilterStore={setFilterStore}
                                    filterCat={filterCat}
                                    setFilterCat={setFilterCat}
                                    filterSubcat={filterSubcat}
                                    setFilterSubcat={setFilterSubcat}
                                    startDate={startDate}
                                    setStartDate={setStartDate}
                                    endDate={endDate}
                                    setEndDate={setEndDate}
                                    stores={storeData}
                                    collections={collectionData}
                                    subcollections={subCollectionData}
                                />

                                <KPICards totals={totals} />

                                <DataTable
                                    data={currentRows}
                                    columns={columns}
                                    striped={true}
                                    center={true}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    onChangePage={handlePageChange}
                                    progressComponent={<Loader />}
                                    progressPending={isLoading}
                                />
                                <Tooltip id="gp-table-tooltip" place="top" style={{ zIndex: 9999, maxWidth: '320px' }} />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}

export default GPReportsComponent;
